import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import ProductsCarouselRenderer from '@peracto/peracto-blocks-tailwind/dist/content/ProductsCarousel/Renderer/ProductsCarouselRenderer'

const ProductsCarouselForm = lazyLoad(() => import('./Form/ProductsCarouselForm'))

const productsCarouselPlugin = settings =>
    createPlugin({
        Renderer: ProductsCarouselRenderer,
        Controls: ProductsCarouselForm,
        ...settings,
    })

const productsCarousel = productsCarouselPlugin()
export default productsCarousel

export { productsCarouselPlugin, ProductsCarouselRenderer }
